import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	Text: null as string | null,
	DodavatelZkt: null as string | null,
	Oddeleni: null as string | null,
	TelNr: null as string | null,
	EMailAdresa: null as string | null,
	DicNr: null as string | null,
	Obec: null as string | null,
	PscNr: null as string | null,
	Ulice: null as string | null,
	PlatbaPZN: null as number | null,
	GSTIN: null as string | null,
	GSTType: null as number | null,
	PAN: null as string | null,
	BankName: null as string | null,
	BankAccountNo: null as string | null,
	DeliveryLeadTime: null as Date | null,
	PurchaseOrderType: null as number | null,
	IsApproved: null as number | null,
	GetSupplierTypeId: null as string | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		PlatbaPZN: [],
		GSTType: [],
		PurchaseOrderType: [],
		GetSupplierTypeId: [],
	},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
